import ThreadPortalItem from "../../common/ThreadPortalItem";

const ThreadList = ({threads}) => {
	if (typeof threads === "object") {
		threads = Object.values(threads);

		if (threads.length > 0) {
			return (
				<div className="p-1 md:p-4">
					<div className="grid grid-cols-2 gap-2 lg:grid-cols-5 lg:gap-4">
						{threads.map((thread, index) => (
							<ThreadPortalItem key={index} thread={thread} />
						))}
					</div>
				</div>
			);
		}
	}
}

const StickyThreadList = ({nodes, threadData}) => {
	return (
		<div>
			{nodes.map((node, index) => (
				<div className="border border-borderColor rounded-lg mb-2 md:mb-4">
					<h3 className="block-minorHeader rounded-lg text-white text-xl font-semibold">
						<a href={node.view_url} title={node.title}>{node.title}</a>
					</h3>

					<ThreadList threads={threadData[node.node_id]} />
				</div>
			))}
		</div>
	);
}

export default StickyThreadList;